import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withKeys as _withKeys, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/cc-logo-black.svg'


const _hoisted_1 = { id: "personalDetailTab" }
const _hoisted_2 = { class: "welcome-box-container" }
const _hoisted_3 = { class: "wizard-action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_InfoBox = _resolveComponent("InfoBox")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_DateInputField = _resolveComponent("DateInputField")!
  const _component_AutoCompleteField = _resolveComponent("AutoCompleteField")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_confirm_dialog = _resolveComponent("confirm-dialog")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        (_ctx.isAfterSignUp)
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 0,
              cols: "12"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, { class: "b-charcoal" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _cache[21] || (_cache[21] = _createElementVNode("div", null, [
                            _createElementVNode("img", { src: _imports_0 })
                          ], -1)),
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_row, { class: "pl-4 pr-4 pt-2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                                    _createElementVNode("h1", null, "Welcome to CODE CLAN", -1)
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                                    _createElementVNode("h4", null, "Lets Get Started!", -1)
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                                    _createElementVNode("span", { class: "f-body-1" }, "Fill out your details to Create a Profile, it should only take a few minutes. ", -1)
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                                    _createElementVNode("span", { class: "f-body-1" }, "We want to know all about your skills, talents and Experience", -1)
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                                    _createElementVNode("span", { class: "f-body-1" }, "Your Profile will Help you Find jobs, Connect with Employers, and will help us determine how code clan can best work for you!", -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_col, {
          cols: "12",
          class: "text-center text-md-left"
        }, {
          default: _withCtx(() => _cache[22] || (_cache[22] = [
            _createElementVNode("h1", null, "Personal Details", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "tab-item-card personal-detail-card" }, {
              default: _withCtx(() => [
                (!_ctx.isAfterSignUp)
                  ? (_openBlock(), _createBlock(_component_v_card_title, { key: 0 }, {
                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                        _createTextVNode(" Personal Details ")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_form, {
                  ref: "frmMain",
                  "lazy-validation": "",
                  class: "form-inputs"
                }, {
                  default: _withCtx(() => [
                    (_ctx.personalDetail)
                      ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InfoBox, {
                              title: "Start by Filling out your Personal Information ....",
                              class: "mb-5"
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  class: "mb-2"
                                }, {
                                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                                    _createElementVNode("span", { class: "f-body-1" }, "Name", -1)
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_TextField, {
                                      readonly: _ctx.isHiringmanager,
                                      dense: "",
                                      outlined: "",
                                      showRequired: "",
                                      placeholder: "First name",
                                      type: "text",
                                      rules: [_ctx.validations.required],
                                      modelValue: _ctx.personalDetail.FirstName,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.personalDetail.FirstName) = $event))
                                    }, null, 8, ["readonly", "rules", "modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4",
                                  sm: "12"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_TextField, {
                                      readonly: _ctx.isHiringmanager,
                                      dense: "",
                                      outlined: "",
                                      showRequired: "",
                                      placeholder: "Last name",
                                      type: "text",
                                      rules: [_ctx.validations.required],
                                      modelValue: _ctx.personalDetail.LastName,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.personalDetail.LastName) = $event))
                                    }, null, 8, ["readonly", "rules", "modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4",
                                  sm: "12"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_TextField, {
                                      readonly: _ctx.isHiringmanager,
                                      dense: "",
                                      outlined: "",
                                      placeholder: "Preferred Name / Nickname",
                                      type: "text",
                                      modelValue: _ctx.personalDetail.NickName,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.personalDetail.NickName) = $event))
                                    }, null, 8, ["readonly", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  class: "mb-2"
                                }, {
                                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                                    _createElementVNode("span", { class: "f-body-1" }, "Date of Birth", -1)
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  md: "4",
                                  sm: "12",
                                  cols: "12"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DateInputField, {
                                      readonly: _ctx.isHiringmanager,
                                      rules: [_ctx.validations.required],
                                      "first-day-of-week": "1",
                                      modelValue: _ctx.personalDetail.BirthDate,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.personalDetail.BirthDate) = $event)),
                                      "hide-actions": "",
                                      placeholder: "Date of birth",
                                      "prepend-icon": "",
                                      max: _ctx.maxBirthDate
                                    }, null, 8, ["readonly", "rules", "modelValue", "max"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  class: "mb-2"
                                }, {
                                  default: _withCtx(() => _cache[26] || (_cache[26] = [
                                    _createElementVNode("span", { class: "f-body-1" }, "Location", -1)
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4",
                                  sm: "12"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_AutoCompleteField, {
                                      readonly: _ctx.isHiringmanager,
                                      outlined: "",
                                      dense: "",
                                      loading: _ctx.isCountryLoading,
                                      disable: _ctx.isCountryLoading,
                                      rules: [_ctx.validations.required],
                                      items: _ctx.countries,
                                      "item-title": "Name",
                                      "item-value": "Id",
                                      placeholder: "Country",
                                      modelValue: _ctx.selectedCountry,
                                      "onUpdate:modelValue": [
                                        _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedCountry) = $event)),
                                        _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetCity()))
                                      ]
                                    }, null, 8, ["readonly", "loading", "disable", "rules", "items", "modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4",
                                  sm: "12"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_AutoCompleteField, {
                                      readonly: _ctx.isHiringmanager,
                                      disabled: _ctx.isCityLoading,
                                      loading: _ctx.isCityLoading,
                                      dense: "",
                                      outlined: "",
                                      placeholder: "City",
                                      rules: [_ctx.validations.required],
                                      items: _ctx.selectedCountryCities,
                                      "item-title": "name",
                                      "item-value": "name",
                                      modelValue: _ctx.selectedCity,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedCity) = $event))
                                    }, null, 8, ["readonly", "disabled", "loading", "rules", "items", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  class: "mb-2"
                                }, {
                                  default: _withCtx(() => _cache[27] || (_cache[27] = [
                                    _createElementVNode("span", { class: "f-body-1" }, "Nationality/Citizenship", -1)
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4",
                                  sm: "12"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_AutoCompleteField, {
                                      readonly: _ctx.isHiringmanager,
                                      dense: "",
                                      outlined: "",
                                      rules: [_ctx.validations.required],
                                      items: _ctx.nationalities,
                                      placeholder: "Nationality",
                                      modelValue: _ctx.personalDetail.Nationality,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.personalDetail.Nationality) = $event))
                                    }, null, 8, ["readonly", "rules", "items", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  class: "mb-2"
                                }, {
                                  default: _withCtx(() => _cache[28] || (_cache[28] = [
                                    _createElementVNode("span", { class: "f-body-1" }, "Email Address", -1)
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4",
                                  sm: "12"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_TextField, {
                                      readonly: _ctx.isHiringmanager,
                                      dense: "",
                                      outlined: "",
                                      placeholder: "Email Address",
                                      showRequired: "",
                                      type: "email",
                                      rules: [_ctx.validations.required],
                                      modelValue: _ctx.personalDetail.Email,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.personalDetail.Email) = $event)),
                                      disabled: ""
                                    }, null, 8, ["readonly", "rules", "modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4",
                                  sm: "12"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_TextField, {
                                      readonly: _ctx.isHiringmanager,
                                      dense: "",
                                      rules: _ctx.personalDetail.SecondaryEmail ? [_ctx.validations.EmailCheck] : [],
                                      outlined: "",
                                      placeholder: "Notification Email",
                                      type: "email",
                                      modelValue: _ctx.personalDetail.SecondaryEmail,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.personalDetail.SecondaryEmail) = $event))
                                    }, null, 8, ["readonly", "rules", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  class: "mb-2"
                                }, {
                                  default: _withCtx(() => _cache[29] || (_cache[29] = [
                                    _createElementVNode("span", { class: "f-body-1" }, "Phone Number", -1)
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4",
                                  sm: "12"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_TextField, {
                                      readonly: _ctx.isHiringmanager,
                                      dense: "",
                                      outlined: "",
                                      placeholder: "Mobile",
                                      rules: [_ctx.validations.required, _ctx.validations.phoneNumber],
                                      type: "text",
                                      modelValue: _ctx.personalDetail.Phone,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.personalDetail.Phone) = $event))
                                    }, null, 8, ["readonly", "rules", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.isAfterSignUp)
      ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_tooltip, {
                top: "",
                attach: ""
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps({ class: "secondary_btn" }, props, {
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.getAllDataAndSubmit(true))),
                    disabled: _ctx.submitting,
                    loading: _ctx.submitting,
                    "prepend-icon": "mdi-check"
                  }), {
                    default: _withCtx(() => _cache[30] || (_cache[30] = [
                      _createTextVNode("Save and exit")
                    ])),
                    _: 2
                  }, 1040, ["disabled", "loading"])
                ]),
                default: _withCtx(() => [
                  _cache[31] || (_cache[31] = _createElementVNode("span", null, "You can save your progress and return to the application process later", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                class: "primary_btn actionButton",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.getAllDataAndSubmit())),
                disabled: _ctx.submitting,
                loading: _ctx.submitting,
                "append-icon": "mdi-chevron-right"
              }, {
                default: _withCtx(() => _cache[32] || (_cache[32] = [
                  _createTextVNode("Next")
                ])),
                _: 1
              }, 8, ["disabled", "loading"])
            ])
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_v_card_actions, {
          key: 1,
          class: "mt-6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              md: "12",
              class: "text-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  class: "primary_btn actionButton",
                  onClick: _ctx.submitForm,
                  disabled: _ctx.submitting,
                  loading: _ctx.submitting,
                  "prepend-icon": "mdi-check"
                }, {
                  default: _withCtx(() => _cache[33] || (_cache[33] = [
                    _createTextVNode("Save")
                  ])),
                  _: 1
                }, 8, ["onClick", "disabled", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showSaveForLaterConfirm,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.showSaveForLaterConfirm) = $event)),
      "max-width": "500",
      onKeydown: _cache[15] || (_cache[15] = _withKeys(($event: any) => (_ctx.showSaveForLaterConfirm = false), ["esc"]))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_confirm_dialog, {
          loading: _ctx.submitting,
          message: _ctx.confirmModel,
          onConfirm: _cache[13] || (_cache[13] = ($event: any) => (_ctx.save(true))),
          onCancel: _ctx.cancelSaving
        }, null, 8, ["loading", "message", "onCancel"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}